"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconArrowDownCircleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8.70717 12.7071C8.31664 13.0976 7.68348 13.0976 7.29295 12.7071L4.29295 9.70711C3.90243 9.31658 3.90243 8.68342 4.29295 8.29289C4.68348 7.90237 5.31664 7.90237 5.70717 8.29289L6.99957 9.5853V4C6.99957 3.44772 7.44729 3 7.99957 3C8.55186 3 8.99957 3.44772 8.99957 4V9.58628L10.293 8.29289C10.6835 7.90237 11.3166 7.90237 11.7072 8.29289C12.0977 8.68342 12.0977 9.31658 11.7072 9.70711L8.70717 12.7071Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M0.999817 10C0.999817 5.02944 5.02925 1 9.99982 1C14.9704 1 18.9998 5.02944 18.9998 10C18.9998 14.9706 14.9704 19 9.99982 19C5.02925 19 0.999817 14.9706 0.999817 10ZM9.99969 16C9.73447 16 9.48012 15.8946 9.29258 15.7071L5.29253 11.7071C4.902 11.3166 4.902 10.6834 5.29252 10.2929C5.68304 9.90237 6.31621 9.90237 6.70674 10.2929L8.99982 12.5859V5C8.99982 4.44771 9.44753 4 9.99982 4C10.5521 4 10.9998 4.44771 10.9998 5V12.5856L13.2925 10.2929C13.683 9.90237 14.3162 9.90237 14.7067 10.2929C15.0973 10.6834 15.0973 11.3166 14.7067 11.7071L10.7068 15.7071C10.5193 15.8946 10.2649 16 9.99969 16Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM16.7071 14.7071L12.7071 18.7071C12.3166 19.0976 11.6834 19.0976 11.2929 18.7071L7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929C7.68342 12.9024 8.31658 12.9024 8.70711 13.2929L11 15.5858V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V15.5858L15.2929 13.2929C15.6834 12.9024 16.3166 12.9024 16.7071 13.2929C17.0976 13.6834 17.0976 14.3166 16.7071 14.7071Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 1.00001C7.71573 1.00001 1 7.71574 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1.00001 16 1.00001ZM16.0001 26C15.5797 26 15.1785 25.8235 14.8944 25.5136L9.39417 19.5136C8.83438 18.9029 8.87561 17.9541 9.48628 17.3943C10.0969 16.8345 11.0458 16.8757 11.6056 17.4864L14.5 20.6438V7.5C14.5 6.67157 15.1716 6 16 6C16.8284 6 17.5 6.67157 17.5 7.5V20.6438L20.3941 17.4864C20.9539 16.8757 21.9028 16.8345 22.5135 17.3942C23.1241 17.954 23.1654 18.9029 22.6056 19.5136L17.1058 25.5136C16.8217 25.8235 16.4206 26 16.0001 26Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;